<template>
  <div class="main-container">
    <!-- Author: Vaishnavi
      Date: 12/12/2019
      Issue Description: Breadcrumb alignment -->
        <breadcrumb :list="breadcrumbList" />
        <div class="margintop-32" />
    <tl-header type="h1">Process FnF</tl-header>
    <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
      You have only view permission.
    </div>
    <div class="radio" :disabled="!ifTeamleaderAnchorPermission">
      <tl-radio
        name="pref"
        label="Manual"
        id="pref1"
        value="manual"
        v-model="pref"
      />
      <tl-radio
        name="pref"
        label="Bulk Upload"
        id="pref2"
        value="bulk"
        v-model="pref"
      />
    </div>
    <br />
    <br />

    <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />

    <div v-if="pref=='manual'">
      <tl-tabs :tabs="tabs">
        <tl-tab>
          <!-- <br /> -->
          <!-- <br /> -->
          <data-table
            :columns="employeeTableColumns"
            :tableData="employeeData"
            :showinrow="false"
            :disabled="!ifTeamleaderAnchorPermission"  
          >
            <template v-slot:rowcontent="slotprops">
              <!-- dropdown section starts here -->
              <div class="action-section" v-if="slotprops.value.column.key=='action'">
                  <img
                    src="@/assets/group-2.png"
                    class="pointer-cursor"
                    @click="dropdown(slotprops.value.record)"
                    alt="actionIcon"
                  />
                  <ul class="action-menu" v-show="employeeData[slotprops.value.index].showDropDown">
                    <li>
                      <span class @click="revokefnf(slotprops.value.record)">Revoke</span>
                    </li>
                    <li>
                      <span class @click="proceedToFnf(slotprops.value.record)">Proceed to FnF</span>
                    </li>
                  </ul>
                </div>
            </template>
          </data-table>
        </tl-tab>
        <tl-tab>
          <fnf-processed />
        </tl-tab>
        <tl-tab>
          <bulk-fnf-revoke @refreshPending="refreshPending"/>
        </tl-tab>
      </tl-tabs>
    </div>
    <div v-if="pref=='bulk'">
        <div class="download-btn marginbot-20">
          <download-button @downloadTemplate="getEmployeeTemplate()"></download-button>
        </div>
        <div class>
          <upload-file :apiUrl="bulkUploadUrl" @uploadTemplate="onUploadTemplate($event)" />        </div>
    </div>
    <pop-up-message
      v-if="showBulkUploadSuccessMsg"
      :message="`${popupMessage}`"
      btnText="Back To Process FNF"
      @back="back"
    ></pop-up-message>
    <pop-up-message
      v-if="showErrorPopup"
      popupType="Warning"
      :popupHeaderMessage="'UPLOAD FAILED!!!'"
      :message="`${popupMessage}`">
      
      
        <template v-slot:bottomContent>
        <div class=" margintop-32">
          <div class="Rectangle margintop-32">
          <span class="Information-message">{{ logMessage }}</span>
        </div>
      </div>
      <div class="margintop-32 custom-container">
      <a :href="logSheetUrl"
        @click="downloadItem(logSheetUrl)"
      ><img src="@/assets/download.svg"  class="img" /> <span class="text">Error Log Sheet</span></a>
          </div>
          <div class="popup-btn-group margintop-32 marginright">
            <button class="btn-popup" type="button" @click="backfromlogpopup()">Back To Process FNF</button>
          </div>
        </template>
    </pop-up-message>
    <pop-up-message
      v-if="showSuccessMsg"
      :message="`${popupMessage}`"
      btnText="Back To Organisation Utilities"
      @back="back"
    ></pop-up-message>
     <pop-up-message
      v-if="showConfirmDeletePopup"
      :message="'Are you sure you want to revoke ?'"
      :popupType="popupType"
      :popupHeaderMessage="'Confirm Revoke'"
    >
      <template v-slot:bottomContent>
        <btn-grp>
          <popup-btn text="Cancel" type="secondary" @click="cancelEvent" />
          <popup-btn text="Revoke" type="primary" @click="revokefnfConfirm" />
        </btn-grp>
      </template>
      </pop-up-message>

  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { api_variables } from "@/apis/variables.js";
import FnfProcessed from "./fnfProcessed.vue";
import BulkFnfRevoke from "./bulkFnfRevoke.vue";

export default {
  components: {
    FnfProcessed,
    BulkFnfRevoke
  },
  data() {
    return {
      breadcrumbList:[
              {
                name: "Organisation",
                url: `/dashboard/${this.$route.params.entity_index}/organisation`
              },
              {
                name: "Utilities",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
              },
              {
                name: "Process FnF",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/fnf`
              }
        ],
      designationList: [],
      bulkUploadUrl: api_variables.SERVICE_UPLOAD_FNF_TEMPLATE,
      showBulkUploadSuccessMsg: false,
      showErrorPopup:false,
      logSheetUrl: null,
      logMessage: null,
      componentKey: 0,
      departmentList: [],
      costCenterList: [],
      locationsList: [],
      bandsList: [],
      gradesList: [],
      pref: "manual",
      search: "",
      popupType: "ConfirmDelete",
      showConfirmDeletePopup:false,
      showConfirmSave:true,
      revokeRecord:"",
      tabs: [
        {
          header: "FnF Pending"
        },
        {
          header: "FnF Processed"
        },
        {
          header: "Bulk Revoke"
        }
      ],
      employeeTableColumns: [
        // {
        //   label: "",
        //   key: "imgSrc"
        // },
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Email ID",
          key: "email_id"
        },
        {
          label: "Resignation Day",
          key: "initiation_date"
        },
        {
          label: "Last Working Day",
          key: "last_working_date"
        },
        {
          label: "Status",
          key: "fnf_status"
        },
        {
          label: "Actions",
          key: "action"
        }
      ],
      employeeData: [],
      criteriaList: [
        'Cost center',
        'Designation',
        'Location',
        'Department',
        'Band',
        'Grade'
      ],
      paygroupList: [
        'All'
      ],
      valueList: [],
      paygroupSelected: [],
      criteriaSelected: '',
      criteriaValue: [],
      errmsg: "",
      toast: false,
      showSuccessMsg: false,
      popupMessage: '',
      fnfValue: false,
      role: ""
    };
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    ...mapState({
      pendingFnf: state => state.dashboard.organisation.processfnf.pending,
      paygroupdata: state => state.onboard.paygroup.data,
      globalEmployeeList: state =>
        state.globalapi.globalemployees.entityWiseData,
      payrollMonth: state => state.payroll.runpayroll.payrollMonth,
      payrollYear: state => state.payroll.runpayroll.payrollYear //fetch employees data
    }),
    ...mapState("onboard/organization", {
      orgid: state => state.id
    }),
    leId() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    ifTeamleaderAnchorPermission() {
        if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
          if(this.fnfValue) {
            return true;
          } else {
            return false;
          }
        }
        return false; 
        // else {
        //   return true 
        // }
    }
  },
  mounted() {
    this.fetchPendingFnfList();
    this.getOrgLeIdList();
  },
  activated() {
    // this.fetchEmplDetails();
    this.fetchPendingFnfList();
    this.fetchPaygroups();
    this.getOrgLeIdList();
  },
  methods: {
    ...mapActions({
      act_fetchEmpById: "onboard/employees/fetchEmpDataById",
      act_fetchAllEmployees: "globalapi/globalemployees/fetchAll",
      act_fetchPending: "dashboard/organisation/processfnf/fetchPending",
      act_changeEditMode: "dashboard/organisation/processfnf/changeEditMode",
      act_delete: "dashboard/organisation/processfnf/delete",
      fetch_template: "dashboard/organisation/processfnf/getEmployeeTemplate",
      act_upload_template: "dashboard/organisation/utilities/processFNF/uploadTemplate",
      act_fetch_paygroups: "onboard/paygroup/fetchAll",
      fetch_bands: "onboard/salary_bands/fetchAll",
      fetch_grades: "onboard/salary_grades/fetchAll",
      fetch_businessunits: "onboard/business_units/fetchAll",
      fetch_cost_center: "onboard/cost_centres/fetchAll",
      fetch_designation: "onboard/designations/fetchAll",
      fetch_location: "onboard/locations/fetchAll",
      getOrgLeList: "onboard/organization/getOrgLeIdList"
    }),

    async getEmployeeTemplate() {
       //console.log("Inside getEmployeeTemplate");
       //console.log(this.payrollMonth, "2222");
      try {
      let data={
          le_id : this.leId,
          financial_year: this.payrollYear,
          month: this.payrollMonth
        }
        let res = await this.fetch_template(data);
        //console.log(res);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    backfromlogpopup(){
      this.showErrorPopup = false;
      this.componentKey += 1;
    },

    async onUploadTemplate(res) {
      try {
        if (res.data || res.status) {
          if(res.data.payload == "") {
            this.popupMessage = res.data.message ? res.data.message : "";
            this.showBulkUploadSuccessMsg = true;
          } else {
            this.popupMessage = res.data.message ? res.data.message : "";
            this.showErrorPopup = true;
            this.logSheetUrl = res.data.payload;
          }
        } else {
          this.toast = true;
          this.errmsg = res.response.data.message;
        }
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },

    // async onUploadTemplate(event) {
    //   let formData = new FormData();
    //   formData.append("file", event);
    //   formData.append("le_id", this.leId);

    //   //console.log("onUploadTemplate:", formData);

    //   try {
    //     let res = await this.act_upload_template(formData);
    //     //console.log('act_upload_template:',res);
    //     if (res.status == 200 || res.status == 201){
    //       this.popupMessage = res.message ? res.message : "";
    //         this.showSuccessMsg = true;
    //     }
    //   } catch (err) {
    //     //console.log('onUploadTemplate Error:',err);
    //     this.toast = true;
    //     this.errmsg = err;
    //   }
    // },

    async fetchPendingFnfList() {
      try {
        let res = await this.act_fetchPending({
          le_id: this.leId
        });
        //console.log("Resss--->",res);
        this.employeeData = [];
        // this.employeeData.push(
        //   await res.data.payload.data.map(emp => {
        //     return this.act_fetchEmpById(emp.employee_id).then(empData => {
        //       if (empData.data.payload.data) {
        //         empData.data.payload.data.fnf_id = emp.id;
        //         empData.data.payload.data.imgSrc = '';
        //         return empData.data.payload.data;
        //       }
        //     });
        //   })[0]
        // );
        res.data.payload.data.forEach(element => { 
          let resignationDate=element.initiation_date == "NaN-NaN-NaN" ?"": element.initiation_date;
          let lastWorkingDate=element.last_working_date == "NaN-NaN-NaN" ?"": element.last_working_date;
          let lastName = element.last_name == null ? '' : element.last_name;
          this.employeeData.push({
            code: element.code,
            name: element.first_name == null ? '' : element.first_name +" "+ lastName,
            email_id: element.email_id,
            fnf_status: element.fnf_status,
            initiation_date: resignationDate,
            last_working_date:lastWorkingDate.split(" ")[0],
            employee_id: element.employee_id,
            le_id: element.le_id,
            fnfID: element.fnfID
          });
        });
      } catch (error) {
        //console.log("error", error);
      }
    },
    
    dropdown(slots) {
      try {
            let idx = this.employeeData.findIndex(obj => {
              return obj.code == slots.code;
            });
            this.employeeData.forEach((data, index) => {
            if (index !== idx) {
              data.showDropDown = false;
              }
            });
            if (idx > -1) {
              this.employeeData[idx].showDropDown = this.employeeData[idx]
              .showDropDown
              ? false
              : true;
              this.employeeData = [...this.employeeData];
            }
      } catch (err) {
          this.toast = true;
          this.errmsg = err;
      }
    },

    async proceedToFnf(record) {
      try {
        await this.act_changeEditMode({ editMode: true, record: record });
        
        this.$router.push({
          path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/processfnf`,
          query: { id: record.employee_id }
        });
      } catch (err) {
        //console.log(err);
      }
    },

    refreshPending(){
      this.fetchPendingFnfList();
    },

    async revokefnfConfirm() {
      try{
          await this.act_delete({
          id: this.revokeRecord
        });
        this.showConfirmDeletePopup = false;
        this.fetchPendingFnfList();
      }
      catch{
        //console.log("error", error);
      }
    },

    async revokefnf(record) {
       this.revokeRecord =record.fnfID
       this.showConfirmDeletePopup=true
      },

    cancelEvent() {
      this.showConfirmDeletePopup = false;
    },

    async fetchPaygroups() {
      try {
        await this.act_fetch_paygroups(this.leId);
        this.paygroupList = [];
        if (this.paygroupdata[this.leId]) {
          for (let paygroup of this.paygroupdata[this.leId]) {
            this.paygroupList.push(paygroup.name);
          }
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async fetchEmplDetails() {
      // let tempArray = []
      try {
        let res = await this.act_fetchAllEmployees({ le_id: this.leId });
        //console.log("employee data", res.data.payload.data);
        this.employeeData = [];
        for (var i = 0; i < res.data.payload.data.length; i++) {
          for (
            var j = 0;
            j < res.data.payload.data[i].EmployeeSalarySetting.length;
            j++
          ) {
            let obj = {
              name: res.data.payload.data[i].name,
              code: res.data.payload.data[i].EmployeeOfficial.employee_id,
              department: res.data.payload.data[i].EmployeeOfficial.department,
              email:
                res.data.payload.data[i].EmployeeOfficial.official_email_id,
              currCtc: res.data.payload.data[i].EmployeeSalarySetting[j].ctc,
              costcenter_id:
                res.data.payload.data[i].EmployeeOfficial.cost_center_id,
              designation_id:
                res.data.payload.data[i].EmployeeOfficial.designation_id,
              department_id:
                res.data.payload.data[i].EmployeeOfficial.buisiness_unit_id,
              manager_id:
                res.data.payload.data[i].EmployeeOfficial.reporting_manager_id
            };
            this.employeeData.push(obj);
            this.$emit("getSelectedEmpData", this.employeeData);
          }
        }
        //console.log("employee data", this.employeeData);
      } catch (error) {
        //console.log("error", error);
      }
    },
    filterData(searchText) {
      this.search = searchText;
    },
    routeToMainStep() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation`
      });
    },
    routeToSubStep() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
      });
    },

    back(){
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
      });
    },
    async fetchValuesList(criteria) {
      try {
        this.valueList = [];
        switch(criteria) {
          case 'Cost center':
                await this.getCostCenter();
                this.valueList = this.costCenterList;
                break;
          case 'Designation':
                await this.getDesignations();
                this.valueList = this.designationList;
                break;
          case 'Location':
                await this.getLocations();
                this.valueList = this.locationsList;
                break;
          case 'Department':
                await this.getDepartment();
                this.valueList = this.departmentList;
                break;
          case 'Band':
                await this.getBands();
                this.valueList = this.bandsList;
                break;
          case 'Grade':
                await this.getGrades();
                this.valueList = this.gradesList;
                break;
          default:
            this.valueList = [];
        }

      } catch (error) {
        //console.log('error', error);
      }
    },
    async getDepartment() {
      try {
        let res = await this.fetch_businessunits(this.orgid);
        if (res.data.status) {
          //console.log(res.data.payload);
          this.departmentList = res.data.payload.data;
          //console.log('departments list', this.departmentList)
        //   if(this.departmentList.length){
        //     this.departmentList.splice(0, 0, { id: "", name: "All" });
        //   }else{
        //     this.departmentList.push({ id: "", name: "All" });
        //   }
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getCostCenter() {
      try {
        let res = await this.fetch_cost_center(this.leId);
        if (res.data.status) {
          //console.log(res.data.payload);
          this.costCenterList = res.data.payload.data;
          //console.log('cost center list', this.costCenterList)
        //   if(this.costCenterList.length){
        //     this.costCenterList.splice(0, 0, { id: "", name: "All" });
        //   }else{
        //     this.costCenterList.push({ id: "", name: "All" });
        //   }
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getBands() {
      try {
        let res = await this.fetch_bands(this.leId);
        if (res.data.status) {
          this.bandsList = res.data.payload.data;
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getGrades() {
      try {
        let res = await this.fetch_grades(this.leId);
        if (res.data.status) {
          this.gradesList = res.data.payload.data;
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getDesignations() {
      try {
        let res = await this.fetch_designation(this.leId);
        if (res.data.status) {
          //console.log(res.data.payload);
          this.designationList = res.data.payload.data;
          //console.log('designations', this.designationList)
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getLocations() {
        try {
          let res = await this.fetch_location(this.leId);
          this.locationsList = res.data.payload.data;
          //console.log('locations', this.locationsList)
          let dataArr = res.data;
          if (dataArr.length){
            this.locationsData = res.data;
          }

          //console.log("fetchlocations:", res);
        } catch (err) {
          //console.log(err);
        }
    },

    back() {
      try {
        this.showBulkUploadSuccessMsg = false;
        this.$router.push({
          path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/fnf`
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    
    async getOrgLeIdList() {
          const org = this.orgid;
          const le = this.leId;
          //console.log("Org:",org);
          //console.log("Le ID",le);
          let bodyParams = {};
          let  data = await this.getOrgLeList({
            data: {
            ...bodyParams
          }});
          this.role = data.data.user.userRole;
          this.fnfValue = data.data.user.permissions.process_fnf;
          //console.log("PL-3406",data);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss";  //margins
.radio {
  display: flex;
  div {
    margin-right: 30px;
  }
}
.btnfilter {
  width: 110px;
  align-self: center;
  background-color: #ffffff;
  border: #34c0be solid 1px;
  color: #34c0be;
  font-weight: bold;
  padding: 10px 5px;
  border-radius: 4px;
}
.fnfbtn {
  width: 135px;
  align-self: flex-start;
  background-color: #ffffff;
  border: #34c0be solid 1px;
  color: #34c0be;
  font-weight: bold;
  padding: 10px 10px;
  border-radius: 4px;
}
.btn-filter {
  width: 135px;
  align-self: end;
  background-color: #ffffff;
  border: #34c0be solid 1px;
  color: #34c0be;
  font-weight: bold;
  padding: 10px 10px;
  border-radius: 4px;
}
.searchsort {
  display: flex;
  .selectdiv {
    width: 15%;
  }
}
.uploadDiv {
  width: 10%;
  margin-left: auto;
  text-align: center;
  justify-content: end;
  padding: 4px 0px 0px 0px;
  button {
    cursor: pointer;
    width: 60%;
    height: 50%;
    border-radius: 4px;
    color: #5d409f;
    border: 1px solid #5d409f;
  }
  img {
    height: 50%;
    margin-bottom: -6px;
  }
}
.sorttext {
  // width: 10%;
  text-align: center;
  line-height: 40px;
  color: #726f75;
  padding: 0px 0px 0px 10px;
}
.sorticons {
  width: 13%;
  padding: 8px 0px 5px 10px;
  span {
    padding-top: 10px;
    padding-left: 10px;
    border-left: 2px solid #34c0be;
  }
}
.sortdrop {
  width: 200px;
}
.sm-img {
  width: 35%;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}

.action-section {
  margin: 0px;
  text-align: center;
  img {
    width: auto;
  }
  .action-menu {
    top: 0px;
    right: 54px;
    left: -182px;
    li {
      padding: 0px;
      padding: 10px 25px;
      font-weight: 500;
      &:not(:last-child) {
        border-bottom: solid 1px #97979759;
      }
    }
  }
}
</style>
